import { _get, _post } from "../../../../http";

// cuentas bancarias para la distribución
export const getCuentasBancariasDistribucion = (distribucionId) => _get(`/cuentaBancaria/distribuciones/${distribucionId}`);

export const postCuentasBancariasDistribucion = (distribucionId, body) =>
  _post(`/cuentaBancaria/distribuciones/${distribucionId}`, body);
